/** Kept dependency-free so offline image tooling can use the same resolver. */
export type AssetEntry = {
  src: string;
  contentType: string;
  sourcePath?: string;
  objectKey?: string;
  bytes?: number;
  sha256?: string;
  downloadName?: string;
  sourceUrls?: string[];
  width?: number;
  height?: number;
  animated?: boolean;
  webpQuality?: number | string;
  original?: {
    objectKey: string;
    sha256: string;
    bytes: number;
    contentType: string;
  };
};

export type AssetRegistry = Record<string, AssetEntry>;

export const resolveAssetReference = (
  value: string,
  registry: AssetRegistry,
): string => {
  const key = value.startsWith('asset:')
    ? value.slice(6)
    : value.startsWith('/assets/')
      ? value.slice(8).split('?')[0]
      : undefined;
  if (key === undefined || key.includes('/')) return value;
  if (!Object.hasOwn(registry, key)) {
    throw new Error(`Unknown static asset: ${key}`);
  }
  return registry[key].src;
};

export const isHostedAsset = (
  value: string,
  baseUrl: string,
  prefix: string,
) => {
  try {
    const url = new URL(value);
    const base = new URL(baseUrl);
    return (
      url.origin === base.origin &&
      url.pathname.startsWith(`${base.pathname.replace(/\/$/, '')}/${prefix}/`)
    );
  } catch {
    return false;
  }
};
